import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { NavigationList } from "../types/NavigationList";
import { NavigateFunction, useLocation, useNavigate } from "react-router";
import { navigationData } from "../data/navigationData";

const defaultExpandedItems = ["overview", "emissions-reduction", "help"];

const renderTreeItems = (items: NavigationList, navigate: NavigateFunction) =>
  items.map((item) => (
    <TreeItem
      key={item.key}
      itemId={item.key}
      label={item.name}
      onClick={() => item.href && navigate(item.href)}
    >
      {item.children && renderTreeItems(item.children, navigate)}
    </TreeItem>
  ));

export const NavigationTree = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(location.pathname);

  useEffect(() => {
    const endingPathSegment = location.pathname.split("/").pop() || "";
    setActiveItem(endingPathSegment);
  }, [location]);

  return (
    <Box sx={{ minHeight: 320, minWidth: 250 }}>
      <SimpleTreeView
        selectedItems={activeItem}
        defaultExpandedItems={defaultExpandedItems}
      >
        {renderTreeItems(navigationData, navigate)}
      </SimpleTreeView>
    </Box>
  );
};
